import api from './api';

export default {
  // --- Skill Types (read-only) ---
  async getSkillTypes() {
    const { data } = await api.get('/admin/platform-skills/types');
    return data;
  },

  // --- Skill Groups ---
  async getGroups(params = {}) {
    const { data } = await api.get('/admin/platform-skills/groups', { params });
    return data;
  },

  async getGroup(id) {
    const { data } = await api.get(`/admin/platform-skills/groups/${id}`);
    return data;
  },

  async createGroup(payload) {
    const { data } = await api.post('/admin/platform-skills/groups', payload);
    return data;
  },

  // Suggestion de traduction francaise d'un groupe (LibreTranslate), sans rien enregistrer.
  async autoTranslateGroup(id) {
    const { data } = await api.post(`/admin/platform-skills/groups/${id}/auto-translate`);
    return data;
  },

  async updateGroup(id, payload) {
    const { data } = await api.patch(`/admin/platform-skills/groups/${id}`, payload);
    return data;
  },

  async archiveGroup(id) {
    const { data } = await api.post(`/admin/platform-skills/groups/${id}/archive`);
    return data;
  },

  async syncGroupEscoMapping(id, escoSkillIds) {
    const { data } = await api.put(`/admin/platform-skills/groups/${id}/esco-mapping`, {
      esco_skill_ids: escoSkillIds,
    });
    return data;
  },

  // --- Platform Skills ---
  async getSkills(params = {}) {
    const { data } = await api.get('/admin/platform-skills', { params });
    return data;
  },

  async getSkill(id) {
    const { data } = await api.get(`/admin/platform-skills/${id}`);
    return data;
  },

  async createSkill(payload) {
    const { data } = await api.post('/admin/platform-skills', payload);
    return data;
  },

  async updateSkill(id, payload) {
    const { data } = await api.patch(`/admin/platform-skills/${id}`, payload);
    return data;
  },

  // Suggestion de traduction francaise (LibreTranslate), sans rien enregistrer.
  async autoTranslateSkill(id) {
    const { data } = await api.post(`/admin/platform-skills/${id}/auto-translate`);
    return data;
  },

  async archiveSkill(id) {
    const { data } = await api.post(`/admin/platform-skills/${id}/archive`);
    return data;
  },

  async bulkAction(ids, action) {
    const { data } = await api.post('/admin/platform-skills/bulk-action', { ids, action });
    return data;
  },

  async bulkUpdate(ids, payload) {
    const { data } = await api.patch('/admin/platform-skills/bulk-update', { ids, ...payload });
    return data;
  },

  async syncSkillEscoMapping(id, escoSkillIds) {
    const { data } = await api.put(`/admin/platform-skills/${id}/esco-mapping`, {
      esco_skill_ids: escoSkillIds,
    });
    return data;
  },
};
